import { render, staticRenderFns } from "./MobileHeaderBottom.vue?vue&type=template&id=771d3d18"
import script from "./MobileHeaderBottom.vue?vue&type=script&lang=ts"
export * from "./MobileHeaderBottom.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports